import React, { Component } from "react";
import { Row, Col, Form, Dropdown, Button, Select, Menu, Empty } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactTags from "react-tag-autocomplete";
import { ShowSkeltons, logMixpanelEventBasic } from "../../../Helpers";
import { getNewsArticles, getBasicSpecialities } from "../../../Services";
import UserContext from "../../../UserContext";
import NewsCard from "./NewsCard";
import NewsOtherTypesCard from "./NewsOtherTypesCard";
import CMENewsCard from "./CMENewsCard";
import { MdClose } from "react-icons/md";
import { BiUpArrowAlt } from "react-icons/bi";
import { IoFilter } from "react-icons/io5";
import EmailSubscriptionCard from "./EmailSubscriptionCard";
import FeaturesCard from "./FeaturesCard";

const { Option } = Select;

class NewsFeed extends Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      newsList: [],
      pageNo: 1,
      perPage: 10,
      hasMore: true,
      totalPages: 0,
      totalArticles: 0,
      currentTab: "all", // 'all' and 'saved',
      showShareModal: false,
      shareText: null,
      shareLink: null,
      isProcessing: true,
      shareNewsId: null,
      showScrollBtn: false,
      facebookShareText: null,
      facebookShareLink: null,
      showNewsHeader: false,
      screenSize: "big",
      specialities: [],
      selectedSpecialities: [],
      enteredSpeciality: null,
      tags: [],
      filterParams: null,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getNewsData();

    this.fetchBasicSpecialities();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  /**
   * @func fetchBasicSpecialities
   * @description it handles fetching specialities
   */
  fetchBasicSpecialities = (searchText = null) => {
    getBasicSpecialities(searchText).then((res) => {
      if (res.data && res.data.hits.total.value > 0) {
        const { hits } = res.data.hits;
        let specialities = [];
        specialities = hits.map((resObj) => {
          const tempObj = resObj._source;
          return {
            name: tempObj.name,
            basic_speciality_id: tempObj.id,
            id: tempObj.id,
          };
        });
        this.setState({ specialities });
      } else {
        this.setState({
          specialities: [],
        });
      }
    });
  };

  /**
   * @function handleResize
   * @desc This funtion sets the screen type
   * in local state
   */
  handleResize = () => {
    const windowSize = window.innerWidth;
    const screenSize = windowSize > 768 ? "big" : "small";
    this.setState({ screenSize });
  };

  /**
   * @function getNewsData
   * @desc This function gets the news Data
   */
  getNewsData = () => {
    const { currentTab, newsList, pageNo, perPage, filterParams } = this.state;

    getNewsArticles(pageNo, perPage, filterParams)
      .then((response) => {
        if (response?.data?.data?.length > 0) {
          const newsArray = response.data.data;
          const allNews = [];
          newsArray.map((obj) => {
            allNews.push(obj.attributes);
          });
          this.setState({
            newsList: [...newsList, ...allNews],
            totalPages: response.data.meta.total_pages,
            totalArticles: response.data.meta.total_records,
          });
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  /**
   * @function getMoreNewsArticles
   * @desc This function gets more news Data
   */
  getMoreNewsArticles = () => {
    const { pageNo, totalPages } = this.state;
    const nextPage = pageNo + 1;
    if (nextPage > totalPages) {
      this.setState({ hasMore: false });
      return false;
    } else {
      let scrollEvent = "Newsfeed Scrolled";
      if (nextPage > 2) scrollEvent = "Newsfeed Scrolled To Next Page";
      // hit scroll event here to log user activity on newsfeed
      logMixpanelEventBasic(scrollEvent);
      this.setState({ pageNo: nextPage }, () => {
        this.getNewsData();
      });
    }
  };

  /**
   * @function handleSwitchTabs
   * @desc This function gets the news Data
   */

  handleSwitchTabs = (value, e) => {
    if (e) e.preventDefault();
    // logMixpanelEvent("News Filtered", value, null, null, "Doctor", getUserId());
    this.setState(
      {
        pageNo: 1,
        currentTab: value,
        newsList: [],
        hasMore: true,
        isProcessing: true,
      },
      () => {
        this.getNewsData();
      }
    );
  };

  /**
   * @function toggleShareModal
   * @desc This function toggles share modal
   */

  toggleShareModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showShareModal: !this.state.showShareModal });
  };

  /**
   * @function handleShareNewsArticle
   * @desc This function toggles share modal
   */

  handleShareNewsArticle = (article, e) => {
    if (e) e.preventDefault();
    const newsDetailLink = `${article.short_link}`;
    this.setState(
      {
        shareNewsId: article.id,
        facebookShareLink: newsDetailLink,
        facebookShareText: `${article.title} — Shared via #kulcare`,
        shareText: `${article.title} — Shared via #kulcare`,
        shareLink: `${process.env.REACT_APP_NEWS_SHARE_LINK}`,
      },
      () => {
        this.toggleShareModal();
      }
    );
  };

  /**
   * @function handleScroll
   * @desc This function handles scroll event
   */
  handleScroll = (event) => {
    const { showScrollBtn } = this.state;
    let scrollTop = window.scrollY;
    if (scrollTop > 100 && !showScrollBtn) {
      this.setState({ showScrollBtn: true });
    } else if (scrollTop <= 100 && showScrollBtn) {
      this.setState({ showScrollBtn: false });
    }
  };

  /**
   * @function redirectUserToNews
   * @desc This function handles redirecting user to news detail
   */
  redirectUserToNews = (newsArticle, type, e) => {
    const { navigateTo } = this.props;
    if (e) e.preventDefault();

    logMixpanelEventBasic("News Item Clicked", `${type} Clicked`);
    // window.open(newsLink, "_blank");
    navigateTo(`/news/${newsArticle.id}`);
  };

  /**
   * @function handleScrollToTop
   * @desc This function handles scrolling to top
   */
  handleScrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  };

  /**
   * @function handleSelectComplaint
   * @description select complaint
   */
  handleSelectSpeciality = (val, obj) => {
    const { selectedSpecialities } = this.state;
    const { serviceData } = obj.props;
    selectedSpecialities.push(serviceData?.name);
    this.setState({
      enteredSpeciality: serviceData.name,
      selectedSpecialities,
    });
    // this.setState({
    //   selectedSpecialities: [...selectedSpecialities, ...obj.props.serviceData]
    // });
  };

  /**
   * @function getSpecialtyOptions
   * @returns Array of Options
   * @description Returns service list as options
   */
  getSpecialtyOptions = () => {
    const { specialities } = this.state;

    return specialities.map((obj) => (
      <Option key={`${obj.name}_${obj.id}`} serviceData={obj} label={obj.name}>
        <div>{obj.name}</div>
      </Option>
    ));
  };

  /**
   * @function onServiceSearch
   * @param "value"
   * @desc This function will handle
   *  searching from service list
   */
  handleSpecialitySearch = (searchTerm) => {
    // replaceling "'" character with empty string, to avoid internal server error
    const searchValue = searchTerm.replace(/'/g, "");
    this.fetchBasicSpecialities(searchValue);
  };

  /**
   * @function handleSpecDelete
   * @param "i"
   * @desc This function will handle
   *  deleting selected speciality
   */
  handleSpecDelete = (i) => {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({ tags });
  };

  /**
   * @function handleSpecSelect
   * @param "tag"
   * @desc This function handles adding speciality, and filtering news according to it
   */
  handleSpecSelect = (tag) => {
    const tags = [].concat(this.state.tags, tag);
    const { selectedSpecialities } = this.state;
    selectedSpecialities.push(tag);

    this.setState({ selectedSpecialities, tags }, () => {
      const specNames = [];
      selectedSpecialities.map((speciality) => {
        specNames.push(speciality.name);
      });
      logMixpanelEventBasic("News feed filtered", "Speciality");
      this.handleFilterNewsData();
    });
  };

  /**
   * @function handleFilterNewsData
   * @desc This function handles processing filter data for making news filter ready
   */
  handleFilterNewsData = () => {
    const { selectedSpecialities } = this.state;
    const specIds = [];
    selectedSpecialities.map((speciality) => {
      specIds.push(speciality.id);
    });

    this.setState(
      {
        filterParams: { ...this.state.filterParams, specIds: specIds.join(", ") },
        pageNo: 1,
        newsList: [],
        isProcessing: true,
      },
      () => {
        this.getNewsData();
      }
    );
  };

  /**
   * @function handleRemoveSpeciality
   * @param "e", "specId"
   * @desc This function handles removing selected speciality, and alter the news results
   */
  handleRemoveSpeciality = (e, specId) => {
    if (e) e.preventDefault();
    const { selectedSpecialities } = this.state;

    const filteredSpecialities = selectedSpecialities.filter(
      (speciality) => speciality.id !== specId
    );
    this.setState({ selectedSpecialities: filteredSpecialities }, () => {
      this.handleFilterNewsData();
    });
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleFilterClick = ({ key }) => {
    const type = key == "all" ? null : key;
    logMixpanelEventBasic("News feed Filtered", "key");
    this.setState(
      {
        filterParams: { ...this.state.filterParams, type },
        pageNo: 1,
        newsList: [],
        isProcessing: true,
      },
      () => {
        this.getNewsData();
      }
    );
  };

  render() {
    const {
      currentTab,
      newsList,
      hasMore,
      totalArticles,
      showShareModal,
      shareText,
      shareLink,
      isProcessing,
      showScrollBtn,
      selectedSpecialities,
      specialities,
    } = this.state;
    const { doctorInviteLink, outerProcessing } = this.props;
    const menu = (
      <Menu
        onClick={this.handleFilterClick}
        items={[
          {
            label: "All",
            key: "all",
          },
          {
            label: "Journal",
            key: "journal",
          },
          {
            label: "Job",
            key: "job",
          },
          {
            label: "CME",
            key: "cme",
          },
          {
            label: "Pharma",
            key: "pharma",
          },
          {
            label: "News",
            key: "news",
          },
          {
            label: "Covid19",
            key: "covid19",
          },
        ]}
      />
    );
    return (
      <>
        <div className="news-section">
          <Row
            type="flex"
            justify="space-between"
            align="middle"
            className="mb-10 mt-10 news-top-row"
            gutter={8}
          >
            <Col className="font-weight-bold font-size-18 font-color-primary news-heading">
              News
            </Col>
            <Col span={20}>
              <Row
                gutter={10}
                type={"flex"}
                justify="end"
                className="news-row-search"
              >
                <Col>
                  <ReactTags
                    onDelete={this.handleSpecDelete}
                    onAddition={this.handleSpecSelect}
                    // tags={tags}
                    suggestions={specialities}
                    placeholderText="Search news by speciality"
                    classNames={{
                      root: "react-tags small",
                      search: "react-tags__search",
                    }}
                    handleInputChange={this.handleSpecialitySearch}
                    addOnBlur
                  />
                </Col>
                <Col>
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <Button size="small">
                      Filter <IoFilter size={14} className="ml-5" />
                    </Button>
                  </Dropdown>
                </Col>
              </Row>
            </Col>
          </Row>
          {selectedSpecialities.length > 0 && (
            <Row>
              <Col>
                <div className="specs_params_wrap mb-10">
                  <div className="specs_params">
                    <ul className="speciality_filtered_list">
                      {selectedSpecialities.map((speciality, index) => {
                        return (
                          <li key={index}>
                            <div>
                              {speciality.name}
                              <a
                                href=""
                                onClick={(e) =>
                                  this.handleRemoveSpeciality(e, speciality.id)
                                }
                                className="cross-icon-link"
                              >
                                <MdClose size={13} color={"#ffffff"} />
                              </a>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          {outerProcessing || isProcessing ? (
            ShowSkeltons(4)
          ) : (
            <>
              {/* mobile visible only  */}
              {/* <Row
            type="flex"
            justify="space-between"
            align="middle"
            className="mb-10 mt-20 mobile-visible-flex"
          >
            <Col className="font-bold">
              {strings.control_centre.news_feed_heading}
            </Col>
            <Col>
              <a href="#" onClick={this.gotoAllNews}>
                {strings.control_centre.see_all}
              </a>
            </Col>
          </Row> */}

              <div className="news-inner-wrap">
                {/* News card start  */}
                <InfiniteScroll
                  dataLength={newsList.length}
                  next={this.getMoreNewsArticles}
                  hasMore={hasMore}
                >
                  {newsList.length > 0 &&
                    newsList.map((newsArticle) => {
                      if (newsArticle.news_type === "NEWS") {
                        return (
                          <NewsCard
                            newsArticle={newsArticle}
                            key={newsArticle.id}
                            handleSaveUnsaveArticle={
                              this.handleSaveUnsaveArticle
                            }
                            handleShareNewsArticle={this.handleShareNewsArticle}
                            redirectUserToNews={this.redirectUserToNews}
                          />
                        );
                      } else {
                        return (
                          <>
                            {newsArticle.news_type === "CME" ? (
                              <CMENewsCard
                                newsArticle={newsArticle}
                                key={newsArticle.id}
                                handleSaveUnsaveArticle={
                                  this.handleSaveUnsaveArticle
                                }
                                handleShareNewsArticle={
                                  this.handleShareNewsArticle
                                }
                                redirectUserToNews={this.redirectUserToNews}
                              />
                            ) : (
                              <NewsOtherTypesCard
                                newsArticle={newsArticle}
                                key={newsArticle.id}
                                handleSaveUnsaveArticle={
                                  this.handleSaveUnsaveArticle
                                }
                                handleShareNewsArticle={
                                  this.handleShareNewsArticle
                                }
                                redirectUserToNews={this.redirectUserToNews}
                              />
                            )}
                          </>
                        );
                      }
                    })}
                </InfiniteScroll>

                {/* News card end  */}
              </div>

              <div>{!isProcessing && newsList.length === 0 && <Empty />}</div>

              {newsList.length > 2 && showScrollBtn && (
                <div className="scroll-to-top-section">
                  <a
                    href="#"
                    className="scroll-top-link"
                    onClick={(e) => this.handleScrollToTop(e)}
                  >
                    <BiUpArrowAlt />
                  </a>
                </div>
              )}
            </>
          )}
        </div>
        <div className="right-section">
          <div className="manage_clinics_wrap sticky">
            {!this.context.userLoggedIn && <EmailSubscriptionCard />}

            <FeaturesCard />
          </div>
        </div>
      </>
    );
  }
}

export default NewsFeed;
